import moment from "moment";
import {clsx} from "clsx"
import {twMerge} from "tailwind-merge"
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import {timezones} from './timezones'
import {fetchSignedUrl, uploadDocumentToS3} from "../services/aws.service";
import React from "react";

dayjs.extend(utc)
dayjs.extend(timezone)

export const _isValidEmail = email => {
  const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regEx.test(email);
}

export const formatDate = (date, formate) => {
  return moment(date).format(formate || 'DD-MMM-YYYY')
}

export const numberOfDays = (date) => {
  return `${Math.abs(moment(date).diff(moment(), 'days')) + 1} day(s)`
}

export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const capitalizeError = (field) => {
  if (field) {
    const result = field.replace(/([A-Z])/g, ' $1');
    return `${result[0].toUpperCase() + result.substring(1).toLowerCase()} is required`;
  }
  return '';
}

export const displayAddess = (city, state, country) => {
  const addressArray = [city, state, country];
  return addressArray.filter((value) => !!value).join(", ")
}

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const dayNames = [
  'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun',
]
export const getAddress = (location) => {
  const addressArray = [location?.addressLine1, location?.addressLine2, location?.city, location?.state, location?.country];
  return addressArray.filter((value) => !!value).join(", ")
}

export const formatCurrency = (value, currency="USD") => {
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
  });
  return USDollar.format(value ?? 0)
}

export const getTimeZoneWithUtcOffset = (timezone) => {
  if(!timezone?.trim()) return ""
  let timeZoneOffset = timezone ? dayjs().tz(timezone).utcOffset() : "";
  let hours = timezone ? (timeZoneOffset >= 0 ? "+" : "-") + (Math.floor(timeZoneOffset / 60)) : "";
  let minutes = timezone ? Math.floor(timeZoneOffset % 60) : "";
  return `${timezone} UTC ${hours}:${minutes}`
}

export const isValidName = (name) => {
  return /^[a-zA-Z]/.test(name); // Check first character is alphabet not number
}

export const isValidBusinessName = (name) => {
  return /^[a-zA-Z0-9 ]+$/.test(name);
}

export const isValidHourlyRate = (rate) => {
  return /^\d{0,3}$/.test(rate);
}

export const isValidMonthlyRate = (rate) => {
  return /^\d{0,5}$/.test(rate);
}

export const getYearList = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const yearList = [];
  for (var i = currentYear; i >= 1950; i--) {
    const year = {
      label: i,
      value: i
    }
    yearList.push(year);
  }
  return yearList;
}

export const sortSkills = (firstSkill, secondSkill) => {
  // First level sorting should be based on year selected on skills
  // Second level sorting should be based on Alphabets
  // Primary skill should be always in first and above 2 rules must apply within Primary skills.

  if (!!firstSkill?.isPrimary && !secondSkill?.isPrimary) {
    return -1;
  } else if (!firstSkill?.isPrimary && !!secondSkill?.isPrimary) {
    return 1;
  }

  if (firstSkill?.experience !== secondSkill?.experience) {
    return secondSkill?.experience - firstSkill?.experience;
  }

  return firstSkill.name.localeCompare(secondSkill.name);
}


export const uploadToS3 = async (file, type, id) => {
  try {
    const payload = {
      s3Input: {
        contentType: file.type,
        fileName: `${type}.${file.name?.split('.').pop()}`,
        uploadType: type,
        uuid: id,
      },
    }
    const response = await fetchSignedUrl(payload)
    const {sUrl, pUrl} = response.data.signedUrl
    if (sUrl) {
      await uploadDocumentToS3(sUrl, file, file.type)
      return pUrl
    }
  } catch (error) {
    console.error(error)
  }
  return ""
}

export const timeZoneList = timezones;

export const getPhoneNumber = (phoneCode, phone) => {
  return `${phoneCode ? `+${phoneCode}` : ''} ${phone ? ` ${phone?.slice(phoneCode?.length, phone?.length)}` : 'Not available'}`
}

export const handleSkillSearch = (props, option, state) => {
  {
    if (!state?.inputValue && !!option?.alias) {
      return null
    }
    if (state?.inputValue && !!option?.alias) {
      return <li {...props}>{option.name} {`(alias)`}</li>
    }
    return <li {...props}>{option.name}</li>
  }
}

export const convertMarkdownToHTML = (markdownText) => {
  if(!markdownText?.trim()) return "";
  // Replace Markdown headers (e.g., # Header) with HTML headers (e.g., <h1>Header</h1>)
  markdownText = markdownText.replace(/^#\s(.+)$/gm, '<h1>$1</h1>');
  markdownText = markdownText.replace(/^##\s(.+)$/gm, '<h2>$1</h2>');
  markdownText = markdownText.replace(/^###\s(.+)$/gm, '<h3>$1</h3>');
  markdownText = markdownText.replace(/^####\s(.+)$/gm, '<h4>$1</h4>');
  markdownText = markdownText.replace(/^#####\s(.+)$/gm, '<h5>$1</h5>');
  markdownText = markdownText.replace(/^######\s(.+)$/gm, '<h6>$1</h6>');

  // Replace Markdown emphasis and strong emphasis with HTML tags
  markdownText = markdownText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  markdownText = markdownText.replace(/\*(.*?)\*/g, '<em>$1</em>');

  // Replace Markdown unordered list items with HTML list items
  markdownText = markdownText.replace(/^\*\s(.+)$/gm, '<li>$1</li>');
  markdownText = markdownText.replace(/<\/li><li>/g, '</li><li>');
  markdownText = `<ul>${markdownText}</ul>`;

  // Replace Markdown links with HTML links
  markdownText = markdownText.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>');

  // Replace Markdown paragraphs with HTML paragraphs
  const paragraphs = markdownText.split(/\n\n/);
  markdownText = paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join('');

  return markdownText;
}

export const CANDIDATE_PUBLIC_ID_MISSING_MESSAGE = 'Candidate public id not available';

export const getPublicProfileLink = (uuid) => {
  return uuid ? `${process.env.REACT_APP_PUBLIC_URL}/profile/${uuid}` : '';
}

export function generateUUID(prefix = '') {
  let uuid = prefix;
  const randomValues = new Uint32Array(4);
  crypto.getRandomValues(randomValues);

  // Set version (4)
  randomValues[2] &= 0x0fff;
  randomValues[2] |= 0x4000;

  // Set variant (RFC4122)
  randomValues[3] &= 0x3fff;
  randomValues[3] |= 0x8000;

  for (let i = 0; i < randomValues.length; i++) {
    uuid += (i < 2 || i > 2 && i < 4 ? '-' : '') + randomValues[i].toString(16).padStart(4, '0');
  }

  return uuid;
}
